import httpManager from "../../shared/utils/httpManager";

export async function customerPlanByToken(token) {
  const url = `/customers/custom-plan/${token}/verify-token/`;
  console.log('customerPlanByToken');
  const response = await httpManager.get(url, { isPublic: true });
  return response.data;
}
